import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaPlay, FaTimes, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

interface Video {
  id: string;
  title: string;
}

const videos: Video[] = [
  { id: "O4qH2b1Y5o8", title: "LUKA SEKARAT RASA - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "C5sMrXv3wtU", title: "AKU TERHINA KAU MENDERITA - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "lUGrrTKsOvs", title: "TERLALU - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "8JbtrSGSxQE", title: "TERIMALAH AKU - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "eD2o7DnIWeU", title: "JANDA 7 KALI - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "II4odrVBDgg", title: "GERHANA LUKA LAMA - KALIA SISKA feat SKA 86 | KENTRUNG BAJIDOR" },
  { id: "j4vK3VXK1Uw", title: "LOS DOL - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "8hlI6z6hvqY", title: "HINGGA TUA KAN KUNANTI - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "BIiLFohALVs", title: "TUMARIMA - KALIA SISKA feat SKA 86 | DJ KENTRUNG" },
  { id: "uh-qVqW5k7w", title: "ANAK DEWA - KALIA SISKA FT SUARA KITA STUDIO CIPT. MUGI LAHIYA" },
  { id: "9uESIH1FUb4", title: "RINDU TAPI MALU - KALIA SISKA feat SKA 86 | KENTRUNG BAJIDOR" },
  { id: "xHVSE4ESw5w", title: "STECU - KALIA SISKA feat SKA 86 | KENTRUNG BAJIDOR " },
  // { id: "Kz6dsZxuwmk", title: "GARAM DAN MADU - KALIA SISKA feat SKA 86" },
  // { id: "h-E7Sqiv6RM", title: "GARA GARA SEBOTOL MINUMAN - KALIA SISKA feat SKA 86 | KENTRUNG BAJIDOR" },
];

const ExploreMusicAll = () => {
  const [activeVideo, setActiveVideo] = useState<Video | null>(null);

  // ESC close
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setActiveVideo(null);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  return (
    <section className="bg-black text-white py-20 px-4 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* TITLE */}
        <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }} className="text-center mb-12">
          <p className="uppercase tracking-[0.3em] text-sm text-pink-400 mb-3">EXPLORE MUSIC</p>
          <h2 className="text-3xl md:text-5xl font-bold">Dengarkan & Tonton Kalia Siska</h2>
        </motion.div>

        {/* GRID (FIX RESPONSIVE) */}
        <motion.div initial={{ opacity: 0, x: -80 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.7 }} viewport={{ once: true }}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {videos.map((video) => (
              <div key={video.id} className="relative group rounded-xl overflow-hidden bg-gray-900">
                <div onClick={() => setActiveVideo(video)} className="cursor-pointer relative">
                  <img alt="" src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`} className="w-full h-[180px] object-cover group-hover:scale-110 transition duration-500" />

                  {/* PLAY */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="bg-black/60 p-3 rounded-full text-red-500">
                      <FaPlay />
                    </div>
                  </div>
                </div>

                <div className="p-3 text-sm">{video.title}</div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* BUTTON */}
        <div className="flex justify-center mt-12">
          <Link to="https://www.youtube.com/results?search_query=kalia+siska+" target="_blank" className="flex items-center gap-2 bg-red-500 hover:bg-red-600 px-8 py-3 rounded-full font-semibold transition hover:scale-105">
            <FaYoutube size={20} />
            Lihat Di Youtube
          </Link>
        </div>
      </div>

      {/* ================= MODAL ================= */}
      <AnimatePresence>
        {activeVideo && (
          <motion.div className="fixed inset-0 bg-black/80 backdrop-blur-md z-50 flex items-center justify-center p-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setActiveVideo(null)}>
            <motion.div className="relative w-full max-w-4xl" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.8, opacity: 0 }} onClick={(e) => e.stopPropagation()}>
              {/* CLOSE */}
              <button onClick={() => setActiveVideo(null)} className="absolute -top-10 right-0 text-white text-xl">
                <FaTimes />
              </button>

              {/* VIDEO */}
              <div className="relative pt-[56.25%] rounded-xl overflow-hidden shadow-2xl">
                <iframe src={`https://www.youtube.com/embed/${activeVideo.id}?autoplay=1`} className="absolute top-0 left-0 w-full h-full" allow="autoplay; encrypted-media" allowFullScreen />
              </div>

              {/* TITLE */}
              <p className="mt-4 text-center text-sm text-gray-300">{activeVideo.title}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default ExploreMusicAll;
